export const PRIMARY = 'header';
export const FOOTER = 'footer';
export const FOOTER_COLUMN_1 = 'footer1';
export const FOOTER_COLUMN_2 = 'footer2';
export const FOOTER_COLUMN_3 = 'footer3';
export const FOOTER_COLUMN_4 = 'footer4';
export const FOOTER_COPYRIGHT = 'footerCopyright';

export default {
  PRIMARY,
  FOOTER,
  FOOTER_COLUMN_1,
  FOOTER_COLUMN_2,
  FOOTER_COLUMN_3,
  FOOTER_COLUMN_4,
  FOOTER_COPYRIGHT,
};
